"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentType = void 0;
// TODO -- Move to checkout-utils
let ContentType = exports.ContentType = /*#__PURE__*/function (ContentType) {
  ContentType["Json"] = "application/json";
  return ContentType;
}({});